// Categorise a booking as 'new', 'current', or 'old' for ease of use in lists & tabs.
//
// new      → still in intake (no deposit paid yet), within the first 7 days
// current  → in active workflow (deposit paid → before completion) OR within the first 30 days
// old      → completed workflows OR older than 60 days
//
// Stage progression (from server): intake_submitted, deposit_paid, report_issued,
//   next_stage_confirmed, next_stage_booked, next_stage_paid, completed
export function bookingAgeStatus(booking) {
  if (!booking) return 'new';
  const stage = booking.stage || 'intake_submitted';
  const created = booking.created_at ? new Date(booking.created_at) : new Date();
  const ageDays = (Date.now() - created.getTime()) / (1000 * 60 * 60 * 24);

  if (stage === 'completed' || ageDays > 60) return 'old';
  if (stage === 'intake_submitted' && ageDays <= 7) return 'new';
  return 'current';
}

export const AGE_STATUS_LABEL = {
  new: 'New',
  current: 'Current',
  old: 'Old'
};

export const AGE_STATUS_BADGE = {
  new: 'bg-blue-100 text-blue-800',
  current: 'bg-amber-100 text-amber-900',
  old: 'bg-slate-200 text-slate-700'
};
